<template>
  <div class="git-lab-media-multiple-input">
    <div class="form-group row" :class="{ 'has-feedback' : options.dirty }">
      <label
      :for="options.name"
      :class="options.fullWidth ? 'col-sm-12' : 'col-sm-4 col-form-label'"
      class="has-icon has-icon-image">{{ options.label }} <span v-if="options.required" class="required">*</span></label>
      <div :class="options.fullWidth ? 'col-sm-12' : 'col-sm-8'">
        <div ref="dropzone">
          <input type="hidden" :name="options.name" :id="options.name + '-url'" :value="value"/>
          Choose File(s)
        </div>
        <br/>
        <div v-for="(val, index) in value" :key="index">
          Image {{ index + 1 }}
          | <a v-show="val" :href="val" target="_blank" style="margin-left: 20px;">Preview</a>
          | <a class="interactive-cursor" @click="deleteImage(val)">Remove</a>
        </div>
        <div class="progress" v-show="isUploading">
          <div class="progress-bar progress-bar-success" role="progressbar" :style="{ width: progress + '%' }"></div>
        </div>
        <span :class="validationClass" v-show="validationMessage">
          {{ validationMessage }}
        </span>
        <span :class="validationIcon" v-show="validationIcon"></span>
      </div>
    </div>
  </div>
</template>

<script>
import {
  validationClass,
  validationIcon,
  validationMessage
} from '@/util/helpers'

export default {
  name: 'GitLabMediaMultipleInput',
  props: {
    value: {
      type: Array
    },
    options: {
      type: Object,
      default () {
        return {
          value: [],
          valid: false,
          dirty: false
        }
      }
    }
  },
  computed: {
    validationClass,
    validationIcon,
    validationMessage
  },
  data () {
    return {
      progress: 0,
      isUploading: false,
      isDirty: false,
      isValid: false,
      hasError: false
    }
  },
  mounted () {
    window.fd.logging = false
    let zone = new window.FileDrop(this.$refs.dropzone, {
      iframe: {
        url: '/api/admin/gitlab-image-uploader',
        fileParam: 'media',
        callbackParam: 'iframeCallback'
      }
    })
    let $vm = this
    zone.event('send', function (files) {
      $vm.isUploading = true
      files.each(function (file) {
        $vm.hasError = false
        let uploadErrors = []
        let acceptFileTypes = /^(image\/(gif|jpe?g|png))|(application\/(pdf|x-pdf|acrobat))|(text\/(pdf|x-pdf))|(applications\/vnd\.pdf)$/
        if (file.type.length && !acceptFileTypes.test(file.type)) {
          uploadErrors.push('Not an accepted file type')
        }
        if (file.size.length && file.size > 10000000) {
          uploadErrors.push('Filesize is too big')
        }
        if (uploadErrors.length > 0) {
          $vm.hasError = uploadErrors.join('\n')
        } else {
          file.event('progress', function (sent, total, xhr, event) {
            $vm.progress = parseInt(sent / total * 100, 10)
          })
          file.event('done', function (xhr) {
            $vm.progress = 0
            $vm.isUploading = false
            let values = $vm.value
            let json = JSON.parse(xhr.responseText)
            values.push(json.url)
            $vm.$emit('input', values)
          })
          file.event('error', function (xhr) {
            uploadErrors.push(xhr.responseText)
            $vm.hasError = uploadErrors.join('\n')
          })
          file.sendTo('/api/admin/gitlab-image-uploader', {
            extraHeaders: true,
            method: 'POST'
          })
        }
      })
    })
    zone.event('iframeDone', function (json) {
      $vm.progress = 0
      $vm.isUploading = false
      let values = $vm.value
      values.push(json.url)
      $vm.$emit('input', values)
    })
    window.fd.addEvent(window.fd.byID('multiple'), 'change', function (e) {
      zone.multiple(e.currentTarget || e.srcElement.checked)
    })
    this.validate(this.options.value)
  },
  methods: {
    validate (val = this.options.value) {
      if (val) {
        this.isDirty = true
        if (this.options.required) {
          if (this.options.value !== '') this.isValid = true
        } else {
          this.isValid = true
        }
      } else if (this.options.required) {
        this.isValid = false
      } else {
        this.isValid = true
      }
    },
    deleteImage (image) {
      this.options.value.splice(this.options.value.indexOf(image), 1)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/inputs/GitLabMediaMultipleInput.vue